export default __webpack_public_path__ + "static/media/Ordeñadora.b60d3457.jpeg";